<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('purchaseOrder.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('purchaseOrder.pageTitle'),
            href: '/admin/purchase-orders',
          },
          {
            text: $t('create'),
            active: true,
          },
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <ts-loading-banner :loading="loading">
          <form class="form-horizontal">
            <div class="row">
              <div class="col-md-4 form-group">
                <div
                  class="
                    ts-border-gray-300
                    ts-border
                    ts-p-3
                    ts-h-full
                    ts-rounded
                    ts-space-y-3
                  "
                >
                  <div class="row">
                    <label
                      class="required form-col-label control-label col-md-3"
                      >{{ $t('purchaseOrder.poDate') }}</label
                    >
                    <div class="col-md-9">
                      <a-date-picker
                        v-model="model.po_date"
                        format="DD-MM-YYYY"
                        valueFormat="DD-MM-YYYY"
                        class="ts-w-full"
                      />
                      <div class="validate" v-if="errors.has('po_date')">
                        {{ errors.first('po_date') }}
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <label
                      class="required form-col-label control-label col-md-3"
                      >{{ $t('purchaseOrder.vendor') }}</label
                    >
                    <div class="col-md-9">
                      <a-select
                        v-model="model.vendor_id"
                        :options="supplierList"
                        showSearch
                        :filterOption="
                          (input, option) =>
                            option.componentOptions.children[0].text
                              .toLowerCase()
                              .indexOf(input.toLowerCase()) >= 0
                        "
                        class="ts-w-full"
                      ></a-select>
                      <div class="validate" v-if="errors.has('vendor_id')">
                        {{ errors.first('vendor_id') }}
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <label class="form-col-label control-label col-md-3">{{
                      $t('purchaseOrder.reference#')
                    }}</label>
                    <div class="col-md-9">
                      <input
                        v-model="model.reference_no"
                        type="text"
                        class="form-control"
                      />
                    </div>
                  </div>
                  <div class="row">
                    <label class="form-col-label control-label col-md-3">{{
                      $t('purchaseOrder.description')
                    }}</label>
                    <div class="col-md-9">
                      <textarea
                        v-model="model.description"
                        rows="9"
                        class="form-control ts-w-full"
                      ></textarea>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-8">
                <div class="form-group">
                  <div style="height: 275px">
                    <Productlist v-model="model" class="ts-h-full" />
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <ItemList
                  v-model="model"
                  :validate="errors"
                  class="
                    ts-shadow-inner ts-border ts-border-gray-200 ts-rounded
                  "
                />
              </div>
            </div>
            <div class="row ts-mt-4">
              <div
                class="
                  col-md-12
                  ts-flex ts-items-center ts-space-x-3 ts-justify-end
                "
              >
                <ts-button
                  @click.prevent="$router.push({ name: 'purchase-order' })"
                  >{{ $t('cancel') }}</ts-button
                >
                <ts-button
                  color="primary"
                  outline
                  :waiting="waiting_new"
                  @click.prevent="onSaveAddNew"
                  >{{ $t('savePrint') }}</ts-button
                >
                <ts-button
                  :waiting="waiting"
                  @click.prevent="onSave"
                  color="primary"
                  >{{ $t('save') }}</ts-button
                >
              </div>
            </div>
          </form>
          <a-modal
            :title="$t('pdf')"
            width="50%"
            v-model="show_pdf"
            :footer="null"
          >
            <ts-preview-pdf v-model="waiting" :src="src" />
          </a-modal>
        </ts-loading-banner>
      </ts-card-wrapper>
    </ts-card>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { Errors } from 'form-backend-validation'
import moment from 'moment'
import ItemList from './components/item-list'
import Productlist from './components/product-list'
import TsTextareaVue from '../../components/common/TsTextarea.vue'

export default {
  name: 'purchaseOrderCreate',
  components: {
    ItemList,
    Productlist,
  },
  data() {
    return {
      loading: false,
      waiting_new: false,
      waiting: false,
      show_pdf: false,
      src: '',
      errors: new Errors(),
      model: {
        po_date: moment().format('DD-MM-YYYY'),
        vendor_id: null,
        description: null,
        reference_no: null,
        po_detail: [],
      },
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    supplierList() {
      return this.$store.state.purchaseOrder.order.suppliers.map((el) => ({
        value: el.vendor_id,
        label: el.vendor_name,
      }))
    },
  },
  methods: {
    ...mapActions('purchaseOrder/order', [
      'getSupplier',
      'getProduct',
      'getMeasure',
      'store',
    ]),
    async fetchData() {
      this.loading = true
      await this.getSupplier()
      await this.getProduct()
      await this.getMeasure()
      this.loading = false
    },
    onSave() {
      this.waiting = true
      this.errors = new Errors()
      this.store(this.model)
        .then((response) => {
          this.$toasted.success(response.message)
          this.clearInput()
          this.$router.push({ name: 'purchase-order' })
        })
        .catch((error) => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    onSaveAddNew() {
      this.waiting_new = true
      this.show_pdf = true
      this.errors = new Errors()
      this.store(this.model)
        .then((response) => {
          this.$toasted.success(response.message)
          this.src = response.url
          this.clearInput()
        })
        .catch((error) => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
          this.show_pdf = false
        })
        .finally(() => {
          this.waiting_new = false
        })
    },
    clearInput() {
      this.model.po_date = moment().format('DD-MM-YYYY')
      this.model.vendor_id = null
      this.model.description = null
      this.model.po_detail = []
    },
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('purchaseOrder/order/CLEAR_SETUP')
    next()
  },
}
</script>